module.exports = __webpack_public_path__ + "img/359.de088b14.svg";